import { render, staticRenderFns } from "./StockItemEntry.vue?vue&type=template&id=2aa5f9f0&"
import script from "./StockItemEntry.vue?vue&type=script&lang=js&"
export * from "./StockItemEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports